import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg, ROLE_LABEL } from "../../lib/api";
import { useGet } from "../../lib/hooks";
import { Button } from "../ui/button";
import { Chips } from "./Chips";

const EMPTY = { everyone: false, roles: [], profile_ids: [], positions: [], user_ids: [] };

function NavRule({ item, opts, onSaved }) {
  const [r, setR] = useState({ ...EMPTY, ...item.rule });
  const [busy, setBusy] = useState(false);
  const set = (k, v) => setR({ ...r, [k]: v });
  const save = async () => {
    setBusy(true);
    try { await api.put(`/features/nav/${item.key}`, r); toast.success(`${item.label} access saved`); onSaved(); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div className="rounded-lg border border-white/10 bg-black/20 p-4 space-y-3" data-testid={`nav-rule-${item.key}`}>
      <div className="flex items-center justify-between">
        <div className="text-sm font-semibold text-slate-100">{item.label}</div>
        <label className="flex items-center gap-2 text-xs text-slate-300"><input type="checkbox" className="accent-[#C2A462]" checked={r.everyone} onChange={(e) => set("everyone", e.target.checked)} data-testid={`nav-rule-everyone-${item.key}`} />Everyone in this organisation</label>
      </div>
      {!r.everyone && <div className="grid md:grid-cols-2 gap-3">
        <div><div className="text-[11px] uppercase tracking-wider text-slate-500 mb-1">Roles</div><Chips testid={`nav-role-${item.key}`} items={["subaccount_admin", "staff"].map((k) => [k, ROLE_LABEL[k]])} value={r.roles} onChange={(v) => set("roles", v)} /></div>
        <div><div className="text-[11px] uppercase tracking-wider text-slate-500 mb-1">Access profiles</div><Chips testid={`nav-profile-${item.key}`} items={opts.profiles.map((p) => [p.id, p.name])} value={r.profile_ids} onChange={(v) => set("profile_ids", v)} /></div>
        <div><div className="text-[11px] uppercase tracking-wider text-slate-500 mb-1">Positions</div><Chips testid={`nav-position-${item.key}`} items={opts.positions.map((p) => [p, p])} value={r.positions} onChange={(v) => set("positions", v)} /></div>
        <div><div className="text-[11px] uppercase tracking-wider text-slate-500 mb-1">People</div><Chips testid={`nav-user-${item.key}`} items={opts.users.map((u) => [u.id, u.name])} value={r.user_ids} onChange={(v) => set("user_ids", v)} /></div>
      </div>}
      <div className="flex justify-end"><Button size="sm" disabled={busy} onClick={save} data-testid={`nav-rule-save-${item.key}`}>Save</Button></div>
    </div>
  );
}

export function SidebarAccessTab() {
  const [items, reload] = useGet("/features/nav");
  const [profiles] = useGet("/access-profiles");
  const [users] = useGet("/users");
  const [positions] = useGet("/r/positions");
  const opts = { profiles: profiles || [], users: (users || []).filter((u) => !u.disabled), positions: [...new Set((positions || []).map((p) => p.name))] };
  return (
    <div className="rounded-xl bg-black p-6 space-y-4 min-h-[40vh]" data-testid="sidebar-access-tab">
      <p className="text-sm text-slate-400">These are the sidebar sections released to your organisation. Choose who sees each one. You, as owner or administrator, always see everything released plus Features Builder and Settings.</p>
      {items && !items.length && <p className="text-sm text-slate-500" data-testid="sidebar-access-empty">Nothing has been released to your organisation yet. Need help? Contact support@boshq.com.au</p>}
      {(items || []).map((it) => <NavRule key={it.key} item={it} opts={opts} onSaved={reload} />)}
    </div>
  );
}
